import React from 'react';
import { imgProps, PHOTO_WIDTHS } from '@/lib/img';

/**
 * Responsive <img>: WebP srcset for uploaded photos, lazy by default, eager + high priority when `priority` is set.
 * Pass a meaningful `alt`; for purely decorative pictures pass `decorative` instead.
 */
export const Img = ({ src, alt = '', decorative = false, priority = false, widths = PHOTO_WIDTHS, sizes = '100vw', className, width, height, ...rest }) => {
  if (!src) return null;
  const a11y = decorative ? { alt: '', role: 'presentation', 'aria-hidden': 'true' } : { alt };
  return (
    <img
      {...imgProps(src, { widths, sizes })}
      {...a11y}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
      fetchPriority={priority ? 'high' : undefined}
      width={width}
      height={height}
      className={className}
      {...rest}
    />
  );
};
